import Sch1 from '../assets/images/sch1.png';
import Sch2 from '../assets/images/sch2.png';
import Sch3 from '../assets/images/sch3.png';
import Sch4 from '../assets/images/sch4.png';
import Sch5 from '../assets/images/sch5.png';
import Sch6 from '../assets/images/sch6.png';

export default [
  {
    img: Sch1,
    title: 'Culture School',
    link: '/school/culture',
    desc: 'We are offering immersive learning  experiences that create opportunities for you and your team to grow and develop together.',
    bgColor: 'bg-[#147D76]'
  },
  {
    img: Sch2,
    title: 'Bankers In Training School',
    link: '/school/bit',
    desc: 'The Bankers-in-Training School has been designed to address the developmental needs of new Graduate hires; as well as fully immerse them into the financial services industry and Wema Bank culture.',
    bgColor: 'bg-[#972682]'
  },
  {
    img: Sch3,
    title: 'Business School',
    link: '/school/business',
    desc: 'Our business school is our technical school that meets the needs of all areas of expertise at Wema. We have several schools including the operations school, treasury school, sales school, data and innovation school, vocational school and open business school.',
    bgColor: 'bg-[#F1A51C]'
  },
  {
    img: Sch4,
    title: 'Banking School',
    link: '/school/banking',
    desc: 'The Banking School offers comprehensive educational programs specifically tailored to cover a wide range of courses including banking operations, risk management, and more.',
    bgColor: 'bg-[#3E7FD8]'
  },
  {
    img: Sch5,
    title: 'Leadership School',
    link: '/school/leadership',
    desc: 'Purple Leadership School is at the pinnacle of our Corporate University that seeks to fuel our current leadership, build resilience, drive succession with a high- performance pipeline and groom the next generation of leaders to thrive and excel in business in an ever - changing world.',
    bgColor: 'bg-[#282941]'
  },
  {
    img: Sch6,
    title: 'SME Business School',
    link: '/school/sme',
    desc: 'The Wema SME Business School is aimed at bridging knowledge gaps for SMEs in Nigeria and guide them in the effective running of their businesses.',
    bgColor: 'bg-[#003763]'
  }
];
